// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1fnsA","title":"BackImages_title__31nL7","images":"BackImages_images__2nEx7"};